import { render, staticRenderFns } from "./PrBlock.vue?vue&type=template&id=9aac6bc0&"
import script from "./PrBlock.vue?vue&type=script&lang=js&"
export * from "./PrBlock.vue?vue&type=script&lang=js&"
import style0 from "./PrBlock.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports